import api from '@/services/api';

interface Rates {
  [currencyCode: string]: number;
}

interface RatesResponse {
  timestamp: number;
  rates: Rates;
}

interface Cache {
  [currenyCode: string]: {
    expiry: number;
    rates: Rates;
  };
}

// must be Euros due to API restrictions
const baseCurrency = 'EUR';

const cache: Cache = {};

// expire rates in 1 day
const newRateExpiryTime = () => {
  const date = new Date();
  return date.setDate(date.getDate() + 1);
};

export const getExchangeValue = (
  amount: number,
  fromCurrency: string,
  toCurrency: string,
): number => {
  // only euro cache atm
  const result = cache[baseCurrency];
  if (result) {
    const {
      [toCurrency]: toRate,
      [fromCurrency]: fromRate,
    } = result.rates;
    return amount * (toRate / fromRate);
  }
  return 0;
};

export const getRates = (currency = baseCurrency) => {
  // save rates to cache or refetch if past expiry time
  const fromCache = cache[currency];
  const expiry = newRateExpiryTime();
  return fromCache && fromCache.expiry < expiry
    ? Promise.resolve(fromCache.rates)
    : api
        .get<RatesResponse>('/rates', { currency })
        .then(response => {
          cache[currency] = {
            rates: response.rates,
            expiry,
          };
          return response.rates;
        });
};

export * from './types';

export default {
  getExchangeValue,
  getRates,
};
